import type {ResponseBody} from '@gongxigames/framework/integrations/rubyplay/types';
import type {IModHandler} from './IModeHandler';

export class NullModeHandler implements IModHandler {

    public getInitSessionRequestPayload(clientVersion?: string): Record<string, any> {
        return {clientVersion};
    }

    public handleInitSessionResponse(body: ResponseBody): void {}

    public getActionRequestPayload(): Record<string, any> {
        return {};
    }

    public handleActionResponse(body: ResponseBody): void {}

    public getOddsAcceptancePayload(): Record<string, any> {
        return {};
    }

    public extendUrl(url: string): string {
        return url;
    }
}